module.exports = __webpack_public_path__ + "c916458ac07525f2bfdd48dfcaf441b6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg67.jpeg
// module id = 80
// module chunks = 0